

<div style=" margin:auto; width:95%; ">

  <div class="searchBoxContainer">

    <mat-form-field class="full">
      <input matInput type='text' style="width:100%; margin-bottom:8px;" #input
        placeholder="Trova indirizzo" [readonly]="disabled" 
         autocomplete="nope" autocorrect="off" autocapitalize="off" />
    </mat-form-field>

  </div>

  <div style='width: 100%; margin:0px;' #mapcnt [ngStyle]="{'height' : height, 'display': showMap ? 'block' : 'none' }">
  </div>

</div>